import { FinanceTypeenum } from '@gtpl/shared-models/common-models';
import { Column,CreateDateColumn,Entity,PrimaryGeneratedColumn,UpdateDateColumn,} from 'typeorm';

@Entity('expenses')
export class  ExpensesEntity {
  @PrimaryGeneratedColumn('increment', { name: 'id' })
  id: number;


    @Column('varchar', {
        nullable: false,
        // length: 30,
        name: 'head',
    })
    head: string;

    @Column('varchar', {
        nullable: false,
        // length: 30,
        name: 'category',
    })
    category: string;

    @Column('int',{
        nullable: false,
        // length: 30,
        name: 'month',
    })
    month:number

    @Column('int',{
        nullable: false,
        // length: 30,
        name: 'year',
    })
    year:number

    @Column({
        type:'enum',
        nullable:false,
        enum: FinanceTypeenum,
        name:'type'
      })
      type:FinanceTypeenum;



    @Column('decimal', {
        nullable: false,
        name: 'amount',
        precision:10,scale:2,
    })
    amount: number;
    
    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;
    
        @UpdateDateColumn({
            name: "updated_at",
            type:'datetime'
        })
        updatedAt: Date;

        
    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @Column('varchar', {
        nullable: true,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;


    @Column('int',{
        nullable: false,
        name: 'plant_id',
    })
    plantId:number






    
}

    
